export const LAUNCH_WEEK_6_ANNOUNCEMENTS = [
  {
    title: 'Keynote: Observability for engineering-first teams',
    description:
      'Teams building AI infrastructure, agent platforms, and dev tools push observability to its limits. System performance is a core part of the product. Our CEO, Pranay, shares why they choose SigNoz, as they\u2019re our largest cohort of customers.',
    image: '/img/events/launch-week-6/engineering-first.webp',
    date: 'Monday - October 12',
    time: '9:00 AM PT',
    registrationUrl: 'https://luma.com/ixczfyuq',
    watchUrl:
      'https://www.linkedin.com/events/signozlaunchweek6-0keynote-obse7515120310010933248/theater/',
    blogUrl: 'https://signoz.io/blog/why-engineering-first-teams-choose-signoz/',
  },
  {
    title: 'New Trace Detail View',
    description:
      'Built for high-volume, AI-scale traces. The new flame graph renders up to 100,000 spans at once. The waterfall supports unlimited spans. New error highlighting, filters, and search take you to the spans you need, however large the trace.',
    image: '/img/events/launch-week-6/trace.webp',
    date: 'Monday - October 12',
    time: '9:30 AM PT',
    registrationUrl: 'https://luma.com/5c8so1z5',
    watchUrl:
      'https://www.linkedin.com/events/meettheall-newtracedetailview-s7514346445626380288/theater/',
    blogUrl: 'https://signoz.io/blog/new-trace-detail-view/',
  },
  {
    title: 'MCP Workshop',
    description:
      "We launched SigNoz MCP earlier this year. Since then, agents have become primary users of SigNoz. In this workshop, we'll walk through useful real-world MCP workflows and show how agents can investigate observability data.",
    image: '/img/events/launch-week-6/signoz-mcp.webp',
    date: 'Tuesday - October 13',
    time: '9:00 AM PT',
    registrationUrl: 'https://luma.com/a8pzbqqt',
    watchUrl:
      'https://www.linkedin.com/events/hands-onsignozmcpworkshop-launc7514376660721336320/theater/',
    blogUrl: 'https://signoz.io/blog/signoz-mcp-observability-workflows/',
  },
  {
    title: 'Infrastructure Monitoring Experience',
    description:
      "We've upgraded infrastructure monitoring for deeper visibility into resource health and faster troubleshooting. See more health and performance signals, a new container view, improved search and filters, and a new query engine.",
    image: '/img/events/launch-week-6/infrastructure-monitoring.webp',
    date: 'Wednesday - October 14',
    time: '9:00 AM PT',
    registrationUrl: 'https://luma.com/gam9999u',
    watchUrl:
      'https://www.linkedin.com/events/newinfrastructuremonitoringexpe7514482365490991104/theater/',
    blogUrl: 'https://signoz.io/blog/new-infrastructure-monitoring-experience/',
  },
  {
    title: 'JSON-native Logs',
    description:
      'SigNoz Cloud now parses JSON log bodies at ingestion and stores them as native JSON, making queries 30% faster. Filter and group by nested body fields directly. Plus, full-text search now covers attributes and resource metadata.',
    image: '/img/events/launch-week-6/json-native-logs.webp',
    date: 'Thursday - October 15',
    time: '9:00 AM PT',
    registrationUrl: 'https://luma.com/j3k51i73',
    watchUrl:
      'https://www.linkedin.com/events/json-nativelogs-fasterqueries-w7515463825773461504/theater/',
    blogUrl: 'https://signoz.io/blog/introducing-json-native-logs/',
  },
  {
    title: 'Fine-grained RBAC',
    description:
      'SigNoz has built one of the most flexible access control models in the observability space. Get precise control over what each user or agent can access, scoped down to individual resources.',
    image: '/img/events/launch-week-6/rbac.webp',
    date: 'Friday - October 16',
    time: '9:00 AM PT',
    registrationUrl: 'https://luma.com/9zyc50cx',
  },
] as const
